import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

import { PaymentSourceQuery } from '@zapier/upsells/src/types';

type Props = {
  accountId: number | undefined;
  skip?: boolean;
};

export const paymentSourceQuery = gql`
  query upsells_paymentSourceQuery($accountId: Int!) {
    account(id: $accountId) {
      id
      paymentSources {
        id
      }
    }
  }
`;

export const usePaymentSource = ({ accountId, skip = false }: Props) => {
  const { data, error, loading: isLoading } = useQuery<PaymentSourceQuery>(
    paymentSourceQuery,
    {
      skip: skip || !accountId,
      variables: {
        accountId,
      },
    }
  );

  const paymentSources = data?.account?.paymentSources ?? [];
  const primarySource = paymentSources[0];

  return {
    error: error?.message,
    isLoading,
    isPaymentMethodProvided: Boolean(primarySource),
  };
};
